
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(165|27|385|740)|2992|6141|9061|9222)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
